define('bundles/sessions/new',['require','sections/sessions/Podio.UI.Login'],function(require) {

  require('sections/sessions/Podio.UI.Login');

});

